import {
  AssetNode,
  FinishTradeDataType,
  getFinishTradeStatus,
  getTradeContentByTypeName,
} from '../../utils';
import { TFunction } from 'i18next';
import {
  getServerLocale,
  initServerTranslation,
} from '@bts-web/utils-lokalise';
import { LegacyFinishTradeKeyClearOnMount } from '../legacy-freeze/LegacyFinishTradeKeyClearOnMount';
import { FinishTradeContentDisplay } from './FinishTradeContentDisplay/FinishTradeContentDisplay';
import { GenericErrorMessage } from '../../../layouts/GenericErrorMessage/GenericErrorMessage';

type FinishTradeControllerProps = {
  searchParams: Record<string, string>;
  transactionData: FinishTradeDataType;
  tradeId?: string;
};

export const FinishTradeController = async ({
  searchParams,
  transactionData,
  tradeId,
}: FinishTradeControllerProps) => {
  const { t } = await initServerTranslation();

  const locale = await getServerLocale();

  const { asset } = transactionData ?? {
    status: 'FAILED',
  };

  const { id, logoUrl, name } = (asset || {}) as NonNullable<AssetNode>;

  const { hasTaxOfflineWarning, reason } = searchParams ?? {};

  const content = getTradeContentByTypeName({
    translationUtil: t as TFunction,
    locale,
    transactionData,
    hasTaxOfflineWarning: hasTaxOfflineWarning?.toLowerCase() === 'true',
    reason,
  });

  if (content) {
    // Legacy-only: clear pending order flow key when trade flow ends (SUCCESS/FAILED). Remove with legacy flow. See trade/AccepBackwardsCompatibilityInterceptor/legacy-freeze/README.md
    return (
      <LegacyFinishTradeKeyClearOnMount
        status={getFinishTradeStatus(transactionData)}
      >
        <FinishTradeContentDisplay
          assetId={id}
          assetLogoUrl={logoUrl ?? ''}
          assetName={name ?? ''}
          isSell={transactionData?.__typename === 'SellTransaction'}
          sellFiatAmount={
            transactionData?.__typename === 'SellTransaction'
              ? transactionData.fiatAmount?.value
              : undefined
          }
          tradeId={tradeId}
          {...content}
        />
      </LegacyFinishTradeKeyClearOnMount>
    );
  } else {
    return <GenericErrorMessage />;
  }
};
